const SITE_URL = 'https://www.olgunkepenk.com';
const BUSINESS_NAME = 'Olgun Kepenk';
const PHONE_DISPLAY = '0501 081 71 61';
const PHONE_SCHEMA = '+905010817161';
const EMAIL = 'info@olgunkepenk.com';

// Sadece gerçekten var olan profiller listelenir; ölü hesap linkleri
// (facebook/twitter/youtube/linkedin yer tutucuları) kaldırıldı.
const SOCIAL_PROFILES = [
  'https://www.instagram.com/olgun_kepenk_veli'
];

const SERVICE_CATALOG = [
  {
    name: 'Otomatik Kepenk Servisi',
    path: '/kepenk-servisi',
    description: 'Otomatik kepenk bakimi, motor kontrolu, kumanda tanitma ve yerinde servis.'
  },
  {
    name: 'Kepenk Tamiri',
    path: '/kepenk-tamiri',
    description: 'Motor, ray, kumanda, alici kart ve mekanik kepenk arizalarinda yerinde tamir.'
  },
  {
    name: 'Sifir Kepenk',
    path: '/sifir-kepenk',
    description: 'Yeni otomatik kepenk kurulumu, kesif, montaj ve teknik destek.'
  },
  {
    name: 'Kepenk Parcalari',
    path: '/kepenk-parcalari',
    description: 'Kepenk motoru, kumanda, alici kart, ray, yay ve yedek parca destegi.'
  }
];

const businessSeo = {
  name: BUSINESS_NAME,
  siteUrl: SITE_URL,
  logo: `${SITE_URL}/logo192-shutter.png`,
  image: `${SITE_URL}/og-image.jpg`,
  description:
    "Istanbul'da otomatik kepenk servisi, kepenk tamiri, bakim, sifir kepenk ve yedek parca hizmetleri sunan yerel servis markasi.",
  phoneDisplay: PHONE_DISPLAY,
  phoneSchema: PHONE_SCHEMA,
  email: EMAIL,
  areaServed: {
    '@type': 'AdministrativeArea',
    name: 'Istanbul, Turkiye'
  },
  priceRange: 'TL',
  socialProfiles: SOCIAL_PROFILES,
  services: SERVICE_CATALOG
};

function buildProviderSchema() {
  return {
    '@type': 'Organization',
    '@id': `${SITE_URL}/#organization`,
    name: BUSINESS_NAME,
    description: businessSeo.description,
    logo: businessSeo.logo,
    image: businessSeo.image,
    url: SITE_URL,
    telephone: PHONE_SCHEMA,
    email: EMAIL,
    areaServed: businessSeo.areaServed,
    sameAs: SOCIAL_PROFILES,
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: PHONE_SCHEMA,
      contactType: 'customer service',
      areaServed: 'TR-34',
      availableLanguage: ['tr']
    }
  };
}

function buildServiceOfferCatalog() {
  return {
    '@type': 'OfferCatalog',
    name: 'Kepenk Hizmetleri',
    itemListElement: SERVICE_CATALOG.map((service) => ({
      '@type': 'Offer',
      url: `${SITE_URL}${service.path}`,
      itemOffered: {
        '@type': 'Service',
        name: service.name,
        description: service.description,
        provider: {
          '@id': `${SITE_URL}/#organization`
        },
        areaServed: businessSeo.areaServed
      }
    }))
  };
}

function buildBaseSchemas() {
  const organization = {
    ...buildProviderSchema(),
    hasOfferCatalog: buildServiceOfferCatalog()
  };

  const webSite = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    '@id': `${SITE_URL}/#website`,
    name: BUSINESS_NAME,
    url: SITE_URL,
    publisher: {
      '@id': `${SITE_URL}/#organization`
    },
    inLanguage: 'tr-TR'
  };

  return [
    {
      '@context': 'https://schema.org',
      ...organization
    },
    webSite,
    buildWebPageSchema(),
    buildBreadcrumbSchema()
  ];
}

// Her sayfa icin WebPage turu (KobiSEO "sayfa turu semasi" kontrolu)
function buildWebPageSchema(path = '/', name = BUSINESS_NAME, description = businessSeo.description) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': `${SITE_URL}${path}#webpage`,
    url: `${SITE_URL}${path}`,
    name,
    description,
    isPartOf: { '@id': `${SITE_URL}/#website` },
    about: { '@id': `${SITE_URL}/#organization` },
    inLanguage: 'tr-TR'
  };
}

// Site ici yol (KobiSEO "kirinti yolu" kontrolu)
function buildBreadcrumbSchema(items) {
  const trail = items && items.length
    ? items
    : [{ name: 'Ana Sayfa', path: '/' }];
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: trail.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: `${SITE_URL}${item.path}`
    }))
  };
}

function buildDistrictServiceSchema(page, profile, kindLabel) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Service',
    '@id': `${page.canonical}#service`,
    name: page.h1,
    serviceType: kindLabel,
    description: page.description,
    url: page.canonical,
    provider: {
      '@id': `${SITE_URL}/#organization`
    },
    areaServed: {
      '@type': 'AdministrativeArea',
      name: `${profile.name}, Istanbul`,
      containsPlace: profile.neighborhoods.map((name) => ({
        '@type': 'Place',
        name
      }))
    }
  };
}

export {
  SITE_URL,
  BUSINESS_NAME,
  PHONE_DISPLAY,
  PHONE_SCHEMA,
  EMAIL,
  SOCIAL_PROFILES,
  SERVICE_CATALOG,
  businessSeo,
  buildBaseSchemas,
  buildDistrictServiceSchema,
  buildProviderSchema,
  buildWebPageSchema,
  buildBreadcrumbSchema
};
